import React, { FC } from 'react';
import Form from 'components/Form';

import { CillitbangPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Cillitbang: FC<CillitbangPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Cillitbang;
